import Modal from 'antd/lib/modal/Modal';
import React from 'react';
import { GeneralFunction } from 'types/common';

import ActionButtons from './components/ActionButtons';
import AppointmentsOnSameDay from './components/AppointmentsOnSameDay';
import NewAppointmentDetail from './components/NewAppointmentDetail';
import { INotaryAppointments } from './types';

const NotaryAppointmentNotification: React.FC<{
  notaryAppointment?: INotaryAppointments;
  visible?: boolean;
  closeModal?: GeneralFunction;
}> = ({ notaryAppointment, visible, closeModal }) => (
  <Modal
    className='notary-appointment-modal'
    visible={visible}
    title='You have an Appointment Request'
    centered
    onCancel={closeModal}
    bodyStyle={{ padding: 0 }}
    footer={null}>
    {notaryAppointment && (
      <>
        <div className='notary-appointment-contents'>
          <NewAppointmentDetail notaryAppointment={notaryAppointment} />
          <AppointmentsOnSameDay notaryAppointment={notaryAppointment} />
        </div>
        <ActionButtons closeModal={closeModal} notaryAppointment={notaryAppointment} />
      </>
    )}
  </Modal>
);

export default NotaryAppointmentNotification;
